module.exports = __webpack_public_path__ + "static/media/TEOC.d53b2671.avif";